
import { api } from "@/api/api";
import BaseModal from "@/components/shared/BaseModal.vue";
import BaseConfirmModalForm from "@/components/shared/modal/BaseConfirmModalForm.vue";
import { NotificationItemType } from "@/shared/enums/notificationItemEnum";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { openNotification } from "@/shared/helpers/store.helpers";
import { ModalBaseData } from "@/shared/interfaces/ModalBaseData.interface";
import { useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
  name: "ApproveModal",
  components: {
    BaseModal,
    BaseConfirmModalForm,
  },
  props: {
    modalData: {
      type: Object as PropType<ModalBaseData>,
      required: true,
    },
    courseId: {
      type: Number,
      required: true,
    },
  },
  emits: ["update", "close", "generateInvoicepdf"],
  setup(props, { emit }) {
    const store = useStore<StoreState>();

    const approveInvoiceBasis = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        await api.clientaccount.approveClientAccountInvoiceBasis(
          props.courseId,
          props.modalData.existingItem.invoiceBasisNumber
        );
        openNotification(store, NotificationItemType.Success, "Fakturagrunnlag er godkjent.");
        emit("generateInvoicepdf", props.modalData.existingItem.invoiceBasisNumber);
        emit("update");
      });
    };

    return {
      approveInvoiceBasis,
    };
  },
});
